module.exports = __webpack_public_path__ + "static/media/Plus-red.e0f3be17.svg";